const prefix = '/files/doc/templates';
const documents = [
  {
    title: 'Заказ-наряд ИП-ИП',
    src: prefix + '/6.3.3-Зh-order-n-ip-ip.pdf',
  },
  {
    title: 'Заказ-наряд ИП-ЮЛ',
    src: prefix + '/6.3.3-Зh-order-n-ip-ul.pdf',
  },
  {
    title: 'Заказ-наряд ФЛ-ИП',
    src: prefix + '/6.3.3-Зh-order-n-fl-ip.pdf',
  },
  {
    title: 'Заказ-наряд ФЛ-ЮЛ',
    src: prefix + '/6.3.3-Зh-order-n-ip-ul.pdf',
  },
  {
    title: 'Заказ-наряд ЮЛ-ИП',
    src: prefix + '/6.3.3-Зh-order-n-ul-ip.pdf',
  },
  {
    title: 'Заказ-наряд ЮЛ-ЮЛ',
    src: prefix + '/6.3.3-Зh-order-n-ul-ul.pdf',
  },
  {
    title: 'Путевой лист заказного автобуса',
    src: prefix + '/6.3.5-pl.pdf',
  },
  {
    title: 'Путевой лист',
    src: prefix + '/6.3.5-pl-ip.pdf',
  },
  {
    title: 'Список детей',
    src: prefix + '/6.3.5-pl-ip.pdf',
  },
  {
    title: 'Список назначенных сопровождающих',
    src: prefix + '/6.3.9-list-of-followers.pdf',
  },
  {
    title:
      'Акт 1 об оказании услуг\n' +
      'по предоставлению вместимости транспортного средства на один\n' +
      'рейс по согласованному маршруту для перевозки пассажиров',
    src: prefix + '/act.pdf',
  },
  {
    title:
      'Договор фрахтования транспортного средства\n' +
      'для перевозки пассажиров и багажа по заказу',
    src: prefix + '/chartering-contract.pdf',
  },

  {
    title: 'Список назначенных сопровождающих',
    src: prefix + '/6.3.9-list-of-followers.pdf',
  },
  {
    title: 'Список назначенных сопровождающих',
    src: prefix + '/6.3.9-list-of-followers.pdf',
  },
  {
    title: 'Список назначенных сопровождающих',
    src: prefix + '/6.3.9-list-of-followers.pdf',
  },
  {
    title: 'Квитанция',
    src: prefix + '/receipt-with-qr.pdf',
  },
  {
    title: 'Маршрут перевозки',
    src: prefix + '/transportation_route.pdf',
  },
  {
    title: 'Информация о водителях',
    src: prefix + '/driver-info.pdf',
  },
  {
    title: 'Информация о медработнике',
    src: prefix + '/paramedic-info.pdf',
  },
  {
    title: 'Список мест размещения для детей на отдых в ночное время',
    src: prefix + '/list-of-place-children-location.pdf',
  },
  {
    title: 'Список посадки и высадки пассажиров в промежуточных пунктах',
    src: prefix + '/list-of-in-out-passangers.pdf',
  },
  {
    title: 'Список набора пищевых продуктов(сухих пайков, бутилированной воды)',
    src: prefix + '/list-of-products.pdf',
  },
  {
    title: 'Счет без НДС',
    src: prefix + '/bill-without-nds.pdf',
  },
  {
    title: 'Счет с НДС',
    src: prefix + '/bill-with-nds.pdf',
  },
  {
    title: 'Фрахтователь - ИП, Фрахтовщик ИП',
    src: prefix + '/charterer-ip-freighter-ip.pdf',
  },
  {
    title: 'Фрахтователь - ИП, Фрахтовщик ЮЛ',
    src: prefix + '/charterer-ip-freighter-ul.pdf',
  },
  {
    title: 'Фрахтователь - ФЛ, Фрахтовщик ИП',
    src: prefix + '/charterer-fl-freighter-ip.pdf',
  },
  {
    title: 'Фрахтователь - ФЛ, Фрахтовщик ЮЛ',
    src: prefix + '/charterer-fl-freighter-ul.pdf',
  },
  {
    title: 'Фрахтователь - ЮЛ, Фрахтовщик ИП',
    src: prefix + '/charterer-ul-freighter-ip.pdf',
  },
  {
    title: 'Фрахтователь - ЮЛ, Фрахтовщик ЮЛ',
    src: prefix + '/charterer-ul-freighter-ul.pdf',
  },
];

export default documents;
